import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import * as React from "react";

interface Props {
  title: string;
  buttons: {
    label: string | JSX.Element;
    selected: () => boolean;
    onClick: () => void;
  }[];
  subLabel?: boolean;
  disabled?: boolean;
}

class ToggleButtonGroup extends React.Component<Props> {
  public render() {
    return (
      <FormControl component="fieldset" margin="dense" fullWidth={true}>
        <FormLabel component="legend">
          <span
            style={
              this.props.subLabel
                ? { fontSize: "10pt", fontStyle: "italic" }
                : {}
            }
          >
            {this.props.title}
          </span>
        </FormLabel>
        <Box marginTop={1}>
          <ButtonGroup>
            {this.props.buttons.map((button, index) => (
              <Button
                disabled={this.props.disabled}
                key={index}
                color="secondary"
                variant={button.selected() ? "contained" : "outlined"}
                onClick={() => button.onClick()}
              >
                {button.label}
              </Button>
            ))}
          </ButtonGroup>
        </Box>
      </FormControl>
    );
  }
}

export default ToggleButtonGroup;



// WEBPACK FOOTER //
// ./src/components/ToggleButtonGroup.tsx